(function($) {
  'use strict'

  var Contact = {
    init: function() {
      if($("#partner-form").length > 0) {
        this.initPartnerForm()
      }
    },

    // Register Partner Form
    initPartnerForm: function() {
      const $form = $('#partner-form');

      if(!$form.length) return;

      // Validate form liên hệ
      $form.validate({
        rules: {
          name: {
            required: true,
            minlength: 2
          },
          email: {
            required: true,
            email: true
          },
          phone: {
            required: true,
            minlength: 10,
            maxlength: 11,
            number: true
          },
          location: {
            required: true
          },
          company: {
            required: true
          },
          'products[]': {
            required: true,
            minlength: 1
          },
          'partners[]': {
            required: true,
            minlength: 1
          },
          consent: {
            required: true
          }
        },
        messages: {
          name: {
            required: "Vui lòng nhập họ tên",
            minlength: "Họ tên phải có ít nhất 2 ký tự"
          },
          email: {
            required: "Vui lòng nhập email",
            email: "Vui lòng nhập email hợp lệ"
          },
          phone: {
            required: "Vui lòng nhập số điện thoại",
            minlength: "Số điện thoại phải có ít nhất 10 số",
            maxlength: "Số điện thoại không được quá 11 số",
            number: "Vui lòng chỉ nhập số"
          },
          location: {
            required: "Vui lòng nhập Tỉnh/Thành phố"
          },
          company: {
            required: "Vui lòng nhập tên công ty"
          },
          'products[]': {
            required: "Vui lòng chọn ít nhất một sản phẩm",
            minlength: "Vui lòng chọn ít nhất một sản phẩm"
          },
          'partners[]': {
            required: "Vui lòng chọn ít nhất một loại đối tác",
            minlength: "Vui lòng chọn ít nhất một loại đối tác"
          },
          consent: {
            required: "Vui lòng đồng ý với điều khoản"
          }
        },
        submitHandler: function(form) {
          const formData = new FormData(form);

          $.ajax({
            url: 'https://mockapi.io/api/v1/partner-contact',
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function(response) {
              // Reset form after successful submission
              $form[0].reset();

              // Show success message
              alert('Gửi form thành công! Chúng tôi sẽ liên hệ với bạn sớm nhất.');
            },
            error: function(xhr,status,error) {
              console.error('Error submitting form:',error);
              alert('Có lỗi xảy ra khi gửi form. Vui lòng thử lại sau.');
            }
          });
        }
      });
    }
  }

  // Khởi chạy khi DOM ready
  $(function() {
    Contact.init()
  })
})(jQuery)